import { FC, useEffect } from 'react';
import { usePartitionChartExport } from '@utils/hook/export/UsePartitionChartExport';
import { CategoryLeaderboardPg } from '@models/CategoryLeaderboard';
import { FactRevenue } from '@utils/pageConfig/Types';
import PerformanceSegmentChart from '../performance-segment-chart/PerformanceSegmentChart';
import { GrowthTypes, KpiDropdownOption } from '../performance-segment-chart/Types';
import * as styles from './PerformanceSegmentMultipleChart.module.scss';
import { useExportContext } from '@hooks/export/context/ExportContext';
import { usePerformanceSegmentMultipleChartScales } from './hooks/UsePerformanceSegmentMultipleChartScales';
import { EXPORT_CHART_SIZE } from '@hooks/export/Model';

export interface PerformanceSegmentMultipleChartProps {
  categoryLeaderboardPg: CategoryLeaderboardPg[];
  selectedGrowthType: GrowthTypes;
  selectedKpi: KpiDropdownOption;
  factRevenue: FactRevenue;
}

const PerformanceSegmentMultipleChart: FC<PerformanceSegmentMultipleChartProps> = ({
  categoryLeaderboardPg,
  selectedGrowthType,
  selectedKpi,
  factRevenue,
}) => {
  const { setChartRefsIsInitialisedStatus, setMultipleExportCallbacks } = useExportContext();
  const { partitionedRowsData, exportCallbacks } = usePartitionChartExport(categoryLeaderboardPg);
  const numberOfCharts = partitionedRowsData.length;
  const chartScales = usePerformanceSegmentMultipleChartScales(categoryLeaderboardPg, selectedGrowthType, selectedKpi);

  useEffect(() => {
    setChartRefsIsInitialisedStatus(Array(numberOfCharts).fill(false));
    setMultipleExportCallbacks(exportCallbacks);
  }, [numberOfCharts, exportCallbacks]);

  return (
    <div className={styles.hidden}>
      {partitionedRowsData.map((rowData, index) => (
        <PerformanceSegmentChart
          key={`${rowData.length}${index}`} // creates a unique key for each element
          categoryLeaderboardPg={rowData}
          selectedGrowthType={selectedGrowthType}
          selectedKpi={selectedKpi}
          factRevenue={factRevenue}
          onExportReady={exportCallbacks[index].onExportReady}
          chartScales={chartScales}
          dimensions={EXPORT_CHART_SIZE}
          index={index}
        />
      ))}
    </div>
  );
};

export default PerformanceSegmentMultipleChart;
